import React, { useState, useRef, useEffect } from 'react';
import useSupercluster from "use-supercluster";
import GoogleMapReact from "google-map-react";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import './ShippingMethod.css';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';
import MapIcon from '@material-ui/icons/Map';
import Modal from '../../AppFooter/Modal';
import LocationIcon from '@material-ui/icons/LocationOn';
import { Backdrop, CircularProgress, ListItem, ListItemText, useTheme } from '@material-ui/core';
import { hexToRgbA } from '../../../helper/Utility';

const HtmlTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 100,
    fontSize: theme.typography.pxToRem(8),
    border: '1px solid #dadde9',
  },
}))(Tooltip);

const storeCellStyles = makeStyles((theme) => ({
  root: props => ({
    marginTop: '10px',
    backgroundColor: props.isSelected ? theme.palette.primary.main : '#f5f5f5',
    '&:hover': {
      backgroundColor: props.isSelected ? hexToRgbA(theme.palette.primary.main, '1') : hexToRgbA(theme.palette.primary.main, '0.1'),
    }
    // backgroundColor: 'khaki'

  }),
}));

const StorePicker = (props) => {
  const [openMap, setOpenMap] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const cart = useSelector(state => state.cartReducer);
  const mainColor = useSelector(state => state.frontConfigReducer.color);
  // For pickup map:
  const [currentLocation, setCurrentLocation] = useState({
    center: {
      lat: 45.5295189,
      lng: -73.6150348
    },
    zoom: 15
  });

  useEffect(() => {
    // if (cart.shipping_address.store?.id) {
    //   props.onStoreSelect(cart.shipping_address.store);
    // }
    // Needed to comment the code above to prevent Fort store or any store to become auto selected based on the nearest store related to customer's address
  }, [])

  // const mapRef = useRef();
  // const points = props.pickupStores.map(store => ({
  //   "type": "Feature",
  //   "properties": {
  //     "cluster": false,
  //     "storeId": store.id,
  //   },
  //   "geometry": { "type": "Point", "coordinates": [parseFloat(store.longitude), parseFloat(store.latitude)] }
  // }));

  // const { clusters } = useSupercluster({
  //   points,
  //   bounds: currentLocation.bounds,
  //   zoom: currentLocation.zoom,
  //   options: { radius: 75, maxZoom: 20 }
  // });


  // const getLocation = () => {
  //   navigator.geolocation.getCurrentPosition(function (position) {
  //     const myLat = position.coords.latitude;
  //     const myLng = position.coords.longitude;

  //     setCurrentLocation({
  //       ...currentLocation,
  //       center: {
  //         lat: myLat,
  //         lng: myLng
  //       }
  //     })
  //   })
  // };

  return (
    <div className="StoreListContainer">
      <button className="StoreMapButton" onClick={() => setOpenMap(true)}>
        {/* <p className="StoreListNameTxt" style={{color: mainColor}}>Show map</p> */}
        <MapIcon style={{ color: mainColor }} />
      </button>
      {
        renderStores()
      }
      <Modal open={openMap} description={pickupStoreMap()} handleClose={() => setOpenMap(false)} title="Locations" />
    </div>
  )

  function renderStores() {
    return props.pickupStores.map((store, i) => {
      return (
        <StoreCell key={i} resetTime={props.resetTime} selectedPickupStore={props.selectedPickupStore} onStoreSelect={props.onStoreSelect} store={store} i={i} />
      )
    })
  };

  function pickupStoreMap() {
    // getLocation();

    return (
      <div style={{ height: 450, width: 700 }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyCwgkgj7F7vLk5zAmvXcQgKp1aYJlb9Nqo", libraries: ['drawing'] }}
          defaultCenter={currentLocation.center}
          defaultZoom={currentLocation.zoom}
        // yesIWantToUseGoogleMapApiInternals
        // onGoogleApiLoaded={({ map }) => {
        //   mapRef.current = map;
        // }}
        // onChange={({ zoom, bounds }) => {
        //   setCurrentLocation({
        //     ...currentLocation,
        //     zoom: zoom,
        //     bounds: [
        //       bounds.nw.lng,
        //       bounds.se.lat,
        //       bounds.se.lng,
        //       bounds.nw.lat
        //     ]
        //   })
        // }}
        >
          {props.pickupStores.map((store, i) => {
            return (
              <Marker
                key={i}
                lat={store.latitude}
                lng={store.longitude}
                type={store.store_type}
                resetTime={props.resetTime}
                selectedPickupStore={props.selectedPickupStore}
                onStoreSelect={props.onStoreSelect}
                setModal={setOpenMap}
                setBackdrop={setBackdropOpen}
                store={store}
              />
            )
          })}

          <Marker
            lat={currentLocation.center.lat}
            lng={currentLocation.center.lng}
            type="customer"
          />
        </GoogleMapReact>

        {/* Backdrop for loading */}
        <Backdrop style={{
          zIndex: 100,
          color: '#fff'
        }} open={backdropOpen}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    )
  }
};

export default StorePicker;

// const StoreCell = (props) => {
//   const mainColor = useSelector(state => state.frontConfigReducer.color);
//   return (
//     <div onClick={selectStore} style={{ border: "1px solid black", backgroundColor: props.selectedPickupStore.id === props.store.id ? mainColor : "white" }} className={`StoreCell`}>
//       <div className="StoreNumDiv">
//         <p className={`StoreListNameTxt ${props.selectedPickupStore.id === props.store.id ? 'TxtWhite' : 'TxtBlack'}`}>{(props.i + 1).toString() + "."}</p>
//       </div>
//       <div className="StoreInfoDiv">
//         <p className={`StoreListNameTxt ${props.selectedPickupStore.id === props.store.id ? 'TxtWhite' : 'TxtBlack'}`}>{props.store.name}</p>
//         <p className={`StoreListDescTxt ${props.selectedPickupStore.id === props.store.id ? 'TxtWhite' : 'TxtBlack'}`}>{props.store.address}</p>
//       </div>
//     </div>
//   )

//   function selectStore() {
//     if (props.selectedPickupStore.id !== props.store.id) {
//       props.onStoreSelect(props.store);
//       props.resetTime();
//     }
//   }
// };

//Marker component for displaying location
const Marker = (props) => {
  const mainColor = useSelector(state => state.frontConfigReducer.color);
  if (props.type === 'customer') {
    return <div className="StoreMapLocationDot"><img src={process.env.PUBLIC_URL + "/bluedot.gif"} alt="current location" /></div>;
    //<LocationDotIcon style={{ borderRadius: "100%", backgroundColor: "rgb(69, 153, 255)", color: 'white', fontSize: 15, transform: 'translate(-50%, -50%)' }} />;
  } else {
    return (
      <HtmlTooltip
        title={
          <React.Fragment>
            <Typography style={{ fontSize: 12 }} color="inherit">{props.store.name}</Typography>
            <em>{props.type} location</em><br />
            {props.store.address}
          </React.Fragment>}
      >
        <LocationIcon fontSize="large" style={{ cursor: 'pointer', transform: 'translate(-50%, -50%)', color: props.type === "Warehouse" ? '#EF6B69' : mainColor }} onClick={() => selectStore()} />
      </HtmlTooltip>
    )
  };

  function selectStore() {
    props.setBackdrop(true);
    if (props.selectedPickupStore.id !== props.store.id) {
      props.onStoreSelect(props.store);
    }
    props.resetTime();
    props.setBackdrop(false);
    props.setModal(false);

  };
};


const StoreCell = (props) => {
  const mainColor = useSelector(state => state.frontConfigReducer.color);
  const classes = storeCellStyles({isSelected: props.selectedPickupStore.id === props.store.id});
  const theme = useTheme();

  // return (
  //   <div onClick={selectStore} style={{ border: "1px solid black", backgroundColor: props.selectedPickupStore.id === props.store.id ? mainColor : "white" }} className={`StoreCell`}>
  //     <div className="StoreNumDiv">
  //       <p className={`StoreListNameTxt ${props.selectedPickupStore.id === props.store.id ? 'TxtWhite' : 'TxtBlack'}`}>{(props.i + 1).toString() + "."}</p>
  //     </div>
  //     <div className="StoreInfoDiv">
  //       <p className={`StoreListNameTxt ${props.selectedPickupStore.id === props.store.id ? 'TxtWhite' : 'TxtBlack'}`}>{props.store.name}</p>
  //       <p className={`StoreListDescTxt ${props.selectedPickupStore.id === props.store.id ? 'TxtWhite' : 'TxtBlack'}`}>{props.store.address}</p>
  //     </div>
  //   </div>
  // )
  return (
    <ListItem className={classes.root} onClick={selectStore} button>
      <ListItemText primary={
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <div className="StoreNumDiv">
            <p className={`StoreListNameTxt ${props.selectedPickupStore.id === props.store.id ? 'TxtWhite' : 'TxtBlack'}`}>{(props.i + 1).toString() + "."}</p>
          </div>
          <div className="StoreInfoDiv">
            <p className={`StoreListNameTxt ${props.selectedPickupStore.id === props.store.id ? 'TxtWhite' : 'TxtBlack'}`}>{props.store.name}</p>
            <p className={`StoreListDescTxt ${props.selectedPickupStore.id === props.store.id ? 'TxtWhite' : 'TxtBlack'}`}>{props.store.address}</p>
          </div>
        </div>
      } />
    </ListItem>
  )

  function selectStore() {
    if (props.selectedPickupStore.id !== props.store.id) {
      props.onStoreSelect(props.store);
      props.resetTime();
    }
  }
};
